import { Controller, useFormContext } from 'react-hook-form';
import React, { FC, FormEvent } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { getNestedValue } from '@efacity/common';

export const textFieldStyle = {
  marginBottom: '8px',
  marginTop: '12px',
  '& label': {
    color: '#666',
    fontSize: 16
  },
  '& p': {
    position: 'absolute',
    top: '38px',
    marginLeft: '1px',
    whiteSpace: 'wrap',
    margin: '3px',
    textWrap: 'pretty'
  }
};

export const groupWrapperStyle: React.CSSProperties = {
  width: '100%',
  position: 'relative',
  marginBottom: '5px'
};

// ? Type of Props the FormInput will receive
export type FormInputTextProps = {
  name: string;
  select?: boolean;
  onValueChange?: (name: string, event: FormEvent) => void;
} & TextFieldProps;

export const defaultRHFSetValueOptions = { shouldDirty: true, shouldTouch: true, shouldValidate: true };

export const FormTextInput: FC<FormInputTextProps> = ({
  name,
  select = false,
  size,
  color,
  helperText = '',
  onValueChange = null,
  inputProps,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field }) => {
        return (
          <div style={{ ...groupWrapperStyle }}>
            <TextField
              {...field}
              select={select}
              variant="outlined"
              fullWidth={true}
              size={size || 'small'}
              color={color || 'primary'}
              sx={textFieldStyle}
              {...otherProps}
              error={!!getNestedValue(errors, name)}
              helperText={(getNestedValue(errors, name)?.message as unknown as string) || helperText}
              inputProps={{
                'data-testid': `${name}-form-text-input`,
                onChange: (event) => onValueChange && onValueChange(name, event),
                ...inputProps
              }}
            />
          </div>
        );
      }}
    />
  );
};
